import { api } from "../utils/api";
import type {
  RestQueryStockBalances,
  RestSetStockBalances,
  RestSetStockPolicies,
  RestStockBalance,
} from "@KassaroAB/shared/types/stockBalance";
import type { ProductId, StoreId } from "@KassaroAB/shared/types/ids";

export const queryStockBalancesApi = (
  storeId: StoreId,
  query: RestQueryStockBalances,
): Promise<RestStockBalance[]> => {
  return api.post(`stores/${storeId}/stockBalances/query`, query);
};

export const setStockBalancesApi = (
  storeId: StoreId,
  balances: RestSetStockBalances,
): Promise<void> => {
  return api.put(`stores/${storeId}/stockBalances`, balances);
};

export const getProductStockBalancesApi = (
  storeId: StoreId,
  productId: ProductId,
): Promise<RestStockBalance[]> => {
  return api.get(`stores/${storeId}/stockBalances/products/${productId}`);
};

export const setStockPoliciesApi = (
  storeId: StoreId,
  policies: RestSetStockPolicies,
): Promise<void> => {
  return api.put(`stores/${storeId}/stockBalances/policies`, policies);
};
